var map = {
	"./animated/butterfly.gif": "ZrAB",
	"./animated/fire.gif": "UDBY",
	"./animated/snowflake.gif": "Ix6h",
	"./animated/spinning-star.gif": "l7DM",
	"./clouds.jpg": "wevW",
	"./construction/metal.gif": "3OGz",
	"./construction/pikachu.gif": "9fS0",
	"./construction/rainbow.gif": "pu5I",
	"./construction/wordart.gif": "PcGg",
	"./imagine.mid": "7qsT",
	"./logo.png": "7Otq",
	"./marble-dark.jpg": "ADHT",
	"./marble-light.gif": "2Zof",
	"./mission.mid": "vuQE",
	"./off-rock.gif": "LvUj",
	"./sarias-song.mid": "1LlO",
	"./sonic.mid": "+dpC",
	"./space.gif": "CKvG",
	"./starwars.mid": "VILj",
	"./water.png": "pRJQ",
	"./xfiles.mid": "8tMZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 0